import styled from 'styled-components'
import { motion } from 'framer-motion'

import { media } from 'src/styles/media'

interface BackgroundProps {
  bgStart: string
  bgEnd: string
}
export const Question = styled(motion.div)<BackgroundProps>`
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 9.8rem 7rem 5.6rem;
  background-image: linear-gradient(
    213deg,
    ${({ bgStart }) => bgStart},
    ${({ bgEnd }) => bgEnd}
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  ${media.desktop} {
    border-radius: 1.6rem;

    :first-of-type,
    :last-of-type {
      box-shadow: 0 1.2rem 3.4rem 0 rgba(0, 0, 0, 0.07);
    }
  }
`

export const ImageWrap = styled.div`
  min-height: 10rem;
  max-width: 24rem;
  flex-shrink: 1;
  flex-grow: 1;
  display: flex;
  padding-bottom: 0.4rem;
  justify-content: center;

  ${media.desktop} {
    max-height: 28.9rem;
  }
`

export const Illustration = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`
